<template>
  <div class="detail-wrap">
    <div class="head">
      <div class="xv">序</div>
      <div class="symbol">证券/代码</div>
      <div class="spj">收盘价/涨幅</div>
      <div class="buy">
        <span>融资买入额</span>
        <!-- <div class="sort">
          <div class="sort-asc"></div>
          <div class="sort-desc sort-desc-selected"></div>
        </div> -->
      </div>
    </div>
    <div class="list">
      <template v-if="!loaded">
        <div style="text-align:center;color:#333333">
          正在加载...
        </div>
      </template>
      <template v-else-if="loaded && list.length">
        <div class="item" v-for="(v, k) in list" :key=k @click="$router.push({path:`/rzrq/${v.SecuAbbr}-${v.SecuCode}/${v.InnerCode}.html`})">
          <div class="xv"><div class="index">{{ k+1 }}</div></div>
          <div class="symbol">
            <div class="market">
              <img v-if="v.SecuMarket === '83'" src="@/assets/sh.png">
              <img v-else-if="v.SecuMarket === '90'" src="@/assets/sz.png">
            </div>
            <div class="code-name">
              <div class="name">{{ v.SecuAbbr }}</div>
              <div class="code">{{ v.SecuCode }}</div>
            </div>
          </div>
          <div class="spj">
            <div :class="{'red': v.UpDownRatio > 0, 'green': v.UpDownRatio < 0, 'black': v.UpDownRatio == 0}">
              <div class="j">{{ v.ClosePrice.toFixed(2) }}</div>
              <div class="zf">{{ (v.UpDownRatio*100).toFixed(2) + '%' }}</div>
            </div>
          </div>
          <div class="buy jine">{{ formatUnit(v.FinanceBuyValue) }}</div>
        </div>
      </template>
      <template v-else-if="loaded">
        <div style="width: 100%;">
          <img style="width:100%;height:auto" src="@/assets/no_data.png">
        </div>
      </template>
    </div>
    <div class="sep"></div>
    <div v-if="list.length" class="more" @click="$router.push({path: '/rzrq-list.html', query: {market: tab, date}})">
      <div class="more-text">查看更多</div>
      <div class="more-icon"><img src="@/assets/more.png"></div>
    </div>
  </div>
</template>
<script>
import rzrq from '@/api/rzrq'
import {request} from '@/api/request'
import Utils from '@/utils/formatUnit'
export default {
  props: {
    tab: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      list: [],
      loaded: false
    }
  },
  watch: {
    async date() {
      this.resetList()
      await this.getTenList()
    },
    async tab() {
      this.resetList()
      await this.getTenList()
    }
  },
  async created() {
    await this.getTenList()
  },
  methods: {
    resetList() {
      this.list = []
      this.loaded = false
    },
    formatUnit(val) {
      if(!val) return '--'
      return Utils.formatUnit(val)
    },
    async getTenList() {
      const res = await this.getRzrqDetail()
      if(res && res.length) 
        this.list = res.slice(0, 10)
      console.log(this.list)
    },
    async getRzrqDetail() {
      if(!this.date) return
      const res = await request.get({
          url: rzrq.queryFinaSecuIndidualDetailRongquanTable,
          params: {market: this.tab, date: this.date}
      })
      this.loaded = true
      if (res && res.length) {
        res.sort((a, b) => b.FinanceBuyValue - a.FinanceBuyValue)
      }
      return res
    }
  },
}
</script>
<style lang="stylus" scoped>
.detail-wrap
  padding .08rem .12rem
.head
  display flex
  color #999999
  font-size .13rem
  margin-bottom .04rem
.xv
  width .3rem
  text-align left
.symbol
  width 1.3rem
  display flex
  justify-content flex-start
  align-items center
  .market
    width .15rem
    height 100%
    padding-top .13rem
    margin-right .02rem
    box-sizing border-box
    img
      display block
  .name
    line-height .24rem
    font-weight 500
    font-size .17rem
    font-family PingFangSC-Medium,PingFang SC
    color #333333
  .code
    line-height .15rem
    font-family DINAlternate-Bold,DINAlternate
    font-weight bold
    color #999999
.spj
  width .73rem
  display flex
  justify-content flex-end
  align-items center
  .j
    font-size .17rem
    font-family DINAlternate-Bold,DINAlternate
    font-weight bold
    line-height .2rem
    margin-bottom .02rem
    text-align right
  .zf
    font-family DINAlternate-Bold,DINAlternate
    font-weight bold
    line-height .15rem
    text-align right
.buy
  width 1.18rem
  display flex
  justify-content flex-end
  align-items center
  .sort
    width .07rem
    height .1rem
    margin-left .04rem
    position relative
    top -.04rem
  .sort-asc
    border .035rem solid transparent
    border-bottom .04rem solid #D8D8D8
    margin-bottom .02rem
  .sort-desc
    border .035rem solid transparent
    border-top .04rem solid #D8D8D8
  .sort-asc-selected
    border-bottom .04rem solid #999999
  .sort-desc-selected
    border-top .04rem solid #999999
.item
  display flex
  height .5rem
  .index
    width .13rem
    text-align center
    font-size .15rem
    color #333333
    line-height .21rem
    font-family PingFangSC-Regular,PingFang SC
    margin-top .06rem
  .jine
    font-size .17rem
    font-family DINAlternate-Bold,DINAlternate
    font-weight bold
    color #333333
    line-height .2rem
  .red
    color #F43737
  .green
    color #1BAA3C
  .black
    color #333333
.sep
  height .01rem
  background #F0F0F0
.more
  display flex
  align-items center
  justify-content center
  height .4rem
  .more-text
    color #666666
    font-size .14rem
  .more-icon
    width .06rem
    height .11rem
    margin-left .04rem
    img
      display block
</style>